import { styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Input, Label, Div, Span } from '@vebox/etui-system-elements';
import { POINT_POSITION } from './utils/index.js';

const RadioInput = styled(Input)`
  display: none;
`;

const _excluded = ["theme"];
const InputLabel = styled(Label).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({}, theme.typography.label), {}, {
    color: theme.palette.text.secondary
  }, props);
})`
  display: block;
  font-size: ${({
  theme
}) => theme.typography.fontSizeSmall};
  cursor: pointer;
  user-select: none;
  text-transform: capitalize;

  ${({
  checked,
  theme
}) => checked && css`
      font-weight: bold;
      color: ${theme.palette.text.primary};
    `};
`;

const Point = styled(Div)`
  position: absolute;
  bottom: 255%;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({
  theme
}) => theme.palette.grey[40]};
  transition: all 0.2s cubic-bezier(0.4, 0.25, 0.3, 1);
  transform: translateY(50%);

  ::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    padding: ${({
  theme
}) => theme.spacing.lg}px;
    transform: translate(-50%, -50%);
    background-color: transparent;
  }

  ${({
  startsFrom,
  theme
}) => {
  switch (startsFrom) {
    case POINT_POSITION.LEFT:
      return css`
          left: ${theme.spacing.xs}px;
        `;
    case POINT_POSITION.RIGHT:
      return css`
          right: ${theme.spacing.xs}px;
        `;
    default:
      return css`
          left: 50%;
          transform: translate(-50%, 50%);
        `;
  }
}};
`;

const PointWrapper = styled(Span)`
  position: relative;
  display: inline-block;
`;

const MultiSwitcherPoint = props => {
  return /*#__PURE__*/createElement(PointWrapper, {
    key: props.title,
    elRef: props.htmlRef
  }, /*#__PURE__*/createElement(RadioInput, {
    id: props.title,
    type: "radio",
    checked: props.checked,
    value: props.value,
    onChange: props.onChange
  }), /*#__PURE__*/createElement(InputLabel, {
    htmlFor: props.title,
    checked: props.checked,
    textAlign: props.sideOf === 'left' ? 'left' : props.sideOf === 'right' ? 'right' : 'center'
  }, props.title, /*#__PURE__*/createElement(Point, {
    startsFrom: props.sideOf
  })));
};

export default MultiSwitcherPoint;
